export default __webpack_public_path__ + "static/media/adfast-logo-background.27359a67.svg";